// Rotas do app de dispositivo (1.6): `/` totem facial; `/acesso/:token`, `/recepcao` e `/sala` (item 5).
import { Navigate, Route, Routes } from "react-router-dom";

import { AccessPage } from "./pages/AccessPage";
import { ReceptionPage } from "./pages/ReceptionPage";
import { RoomPage } from "./pages/RoomPage";
import { TotemPage } from "./pages/TotemPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<TotemPage />} />
      <Route path="/acesso/:token" element={<AccessPage />} />
      <Route path="/recepcao" element={<ReceptionPage />} />
      <Route path="/sala" element={<RoomPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
